export const ACTIVO = "activo";
export const EN_PROCESOS_DE_CIERRE = "En Proceso de cierre";
export const ELIMINADO = "eliminado";
export const CERRADO = "cerrado";
export const CERRADO_CON_OBS = "cerrado con observacion";
export const EN_PROCESOS_DE_CIERRE_2 = "Pendiente de eliminacion";
